import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../lib/api";
import { toast, Toaster } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("samholman@mail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Authenticated");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="login-page">
      <Toaster theme="dark" position="top-right" />
      <div className="w-full max-w-md glass p-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center font-bold text-[#0f1420] text-[15px]" style={{ background: "linear-gradient(135deg, var(--violet), var(--cyan))" }}>IE</div>
          <div>
            <div className="font-semibold tracking-tight text-[16px]">InsidEdge</div>
            <div className="mono text-[10px] text-[color:var(--text-tertiary)]">SYD1 · v1.0</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-[color:var(--text-tertiary)] mb-2 font-medium">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mono w-full bg-black/25 border border-white/[0.06] rounded-xl px-4 py-2.5 text-sm outline-none focus:border-[color:var(--cyan)] focus:bg-black/35"
              required
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-[color:var(--text-tertiary)] mb-2 font-medium">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mono w-full bg-black/25 border border-white/[0.06] rounded-xl px-4 py-2.5 text-sm outline-none focus:border-[color:var(--cyan)] focus:bg-black/35"
              required
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="btn-primary w-full py-3 mt-2"
          >
            {loading ? "Authenticating…" : "Access Terminal"}
          </button>
          <div className="text-[11px] text-[color:var(--text-tertiary)] pt-2 border-t border-white/[0.04]">
            Personal research only. Not financial advice.
          </div>
        </form>
      </div>
    </div>
  );
}
